import { Component, createElement } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error untyped JS module
import { classNameFix, getPassThroughProps, getValue } from './utils';
import { I18nHMRContext } from '../internal/i18n-internal';
export default class FormattedHTMLMessage extends Component {
  render() {
    const {
      useGap,
      message,
      options
    } = this.props;
    const props = classNameFix(getPassThroughProps(this.props));

    // must use dangerouslySetInnerHTML prop to display embedded HTML
    return /*#__PURE__*/createElement('i18n-string', Object.assign({}, props, {
      dangerouslySetInnerHTML: {
        __html: getValue({
          useGap,
          message,
          options
        })
      }
    }));
  }
}
FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextType = I18nHMRContext;
FormattedHTMLMessage.propTypes = {
  message: PropTypes.string.isRequired,
  options: PropTypes.object,
  useGap: PropTypes.bool
};
FormattedHTMLMessage.isI18nElement = true;
FormattedHTMLMessage.defaultProps = {
  options: {},
  useGap: false
};